import React, { useMemo, useState } from 'react';
import '../../../../styles/Table-ext.css';
import { useTranslation } from 'react-i18next';
import { useGetCustomService } from 'hooks/rest/useGetCustomService';
import { getKudiNotesColumns } from '../../constants';
import { useFormatting } from '../../../../../../../../../../locale';
import { Table } from '../../../../../../../../../../ui-library';
import { DEFAULT_PAGE_SIZE } from '../../../../../../../Dashboard/components/OverviewApplications/constants/const';
import Preloader from '../../../../../../../../../../components/Preloader';
import '../../styles/styles.css';

const ShadowAccountsTable = ({ portfolioId, productKey, currency }: any) => {
    const { t } = useTranslation();
    const { getFormattedDate, getFormattedNumber } = useFormatting();
    const [currentPage, setCurrentPage] = useState(1);

    const { data: kudiNotesResponse, isLoading: inProgress, error } = useGetCustomService({
        service: 'planService',
        api: 'getKudiNote',
        payload: {
            portfolioId,
            params: { pageNumber: currentPage, pageSize: DEFAULT_PAGE_SIZE },
        },
        enabled: !!portfolioId,
        refetchOnWindowFocus: false,
    });

    const notes = kudiNotesResponse?.data?.notes ?? [];
    const notesCount = kudiNotesResponse?.data?.total ?? 0;

    const columns = useMemo(() => getKudiNotesColumns({
        productKey, t, getFormattedDate, getFormattedNumber, currency,
    }), [productKey, t, getFormattedDate, getFormattedNumber, currency]);

    return (
        <div className="fz-shadow-account-table">
            <Preloader isLoading={inProgress} error={error}>
                <Table
                    columns={columns}
                    data={notes}
                    paging={{
                        total: notesCount || 0,
                        pageSize: DEFAULT_PAGE_SIZE,
                        currentPage,
                    }}
                    onChange={(paging: any) => setCurrentPage(paging?.currentPage)}
                />
            </Preloader>
        </div>
    );
};

export default ShadowAccountsTable;
